module.exports = class HighlightCurrent {
    constructor(menuNode) {
        this.menu = menuNode;
        this.menuLinks = this.menu.querySelectorAll('a');
        this.isLinkFound = false;

        this.highlightCurrentLink = this.highlightCurrentLink.bind(this);
    }

    init() {
        this.highlightCurrentLink();
        this.addEventListeners();
    }

    addEventListeners() {
        window.addEventListener('hashchange', this.highlightCurrentLink);
    }

    removeEventListeners() {
        window.addEventListener('hashchange', this.highlightCurrentLink);
    }

    highlightCurrentLink() {
        const $fidInput = $('.js-folder-id');
        this.menuLinks.forEach(link => {
            link.classList.remove('m-current');

            if (link.href === window.location.href || ($fidInput.length && $fidInput.data('fid') === $(link).data('fid'))) {
                link.classList.add('m-current');
                this.isLinkFound = true;
            }
        });

        if (!this.isLinkFound && window.location.href.includes('?fid=')) {
            this.highlightFirstElement();
        }
    }

    highlightFirstElement() {
        this.menuLinks[0].classList.add('m-current');
    }
};
